export var SOCIAL_REASON_TRANSLATIONS = {
    socialReasonInformation: {
        fields: {
            legal_information: 'Informaciones legales',
            confirm_registration: 'Para confirmar el registro de tu restaurante',
            restaurant: 'Restaurante',
            confirm_company_name: 'El campo es para confirmar la razón social de tu restaurante. Se llena automáticamente.',
            legal_representative: 'Representante Legal',
            socialReasonName: {
                placeHolder: 'Razón Social',
                required: 'La razón social del restaurante es requerida',
            },
            personType: {
                placeHolder: 'Tipo de persona',
                required: 'El tipo de persona es requerido',
            },
            contributorType: {
                placeHolder: 'Tipo de contribuyente',
                required: 'Seleccione el tipo de contribuyente',
            },
            societaryType: {
                placeHolder: 'Tipo de Societario',
                required: 'El tipo de Societario es requerido',
            },
            commercialBusinessType: {
                placeHolder: 'Giro Comercial',
                required: 'El giro comercial es requerido',
            },
            comuna: {
                placeHolder: 'Comuna',
                required: 'La comuna es requerida',
            },
            regime: {
                placeHolder: 'Régimen tributario',
                required: 'El régimen tributario es requerido',
            },
            socialReasonDocumentType: {
                placeHolder: 'Tipo de documento',
                required: 'El tipo de documento del restuarante es requerido',
            },
            socialReasonDocumentId: {
                placeHolder: 'Número del documento',
                required: 'El numero de documento del restuarante es requerido',
                cnpjError: 'Lo sentimos, ocurrio un error obteniendo la información a partir de su CNPJ',
                cnaeError: 'CNAE no aceptado <br> Lamentablemente, su CNAE no se acepta para el registro en Rappi.<br>Para continuar, te pedimos que realices un simple cambio, agregando una CNAE válida para la industria alimentaria.',
                fiscalValidationError: 'No se pudo realizar la validacion de la razon social ingresada, por favor revise que los datos ingresados sean correctos.',
                socialReasonDuplicateError: 'Lo sentimos, ya existe un restaurante con el ID de esta razón social. Si deseas abrir una nueva tienda, por favor ingresa al Portal Partners > Mis tiendas, con tu correo {{owner}}',
            },
            legalAgentFirstName: {
                placeHolder: 'Nombre',
                required: 'El nombre del representante legal es requerido',
            },
            legalAgentLastName: {
                placeHolder: 'Apellido',
                required: 'El apellido del representante legal es requerido',
            },
            legalAgentDocumentType: {
                placeHolder: 'Tipo de documento',
                required: 'El tipo de documento del representante es requerido',
            },
            legalAgentDocumentId: {
                placeHolder: 'Número del documento',
                required: 'El numero de documento del representante es requerido',
            },
            agentReception: {
                placeHolder: 'Mi negocio es agente de retención',
            },
            specialContributor: {
                placeHolder: 'Mi negocio es contribuyente especial',
            },
            typeContributor: 'Tipo de contribuyente',
            capitalRegime: 'Régimen capital',
            zipCode: 'Código postal',
            streetType: 'Tipo de vialidad',
            streetName: 'Nombre de vialidad',
            outsideNumber: 'Número exterior',
            interiorNumber: 'Número interior',
            location: 'Localidad',
            colony: 'Colonia',
            municipality: 'Municipio',
            federalEntity: 'Entidad federativa',
            regimeFiscal: 'Régimen fiscal',
            cfdiUse: 'Uso de CFDI',
        },
    },
};
